"use client";
export default function NotebookDocument({onProjects}: {onProjects: () => void}) {
return (<section className="console-notebook-page">
                    <span className="console-eyebrow">
                      FROM THE NOTEBOOK / A WORKING SKETCH
                    </span>
                    <h3>
                      How does this
                      <br />
                      <em>actually work?</em>
                    </h3>
                    <svg
                      viewBox="0 0 620 230"
                      fill="none"
                      role="img"
                      aria-label="A sketch connecting a question to understanding, a build, and testing, then looping back to the question"
                    >
                      <path
                        d="M146 92h45m146 0h42m145 0h31M541 119v62H81v-61"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeDasharray="4 5"
                      />
                      <path
                        d="m183 86 9 6-9 6m188-12 9 6-9 6M87 130l-6-10-6 10"
                        stroke="currentColor"
                        strokeWidth="1.5"
                      />
                      {[
                        [20, "Question"],
                        [195, "Understand"],
                        [383, "Build & test"],
                      ].map(([x, label]) => (
                        <g key={label} transform={"translate(" + x + " 54)"}>
                          <path
                            d="M0 2 130 0l-2 78L2 80Z"
                            stroke="currentColor"
                            strokeWidth="1.7"
                          />
                          <text
                            x="65"
                            y="45"
                            textAnchor="middle"
                            fill="currentColor"
                            fontSize="17"
                            fontFamily="Georgia, serif"
                          >
                            {label}
                          </text>
                        </g>
                      ))}
                      <text
                        x="310"
                        y="208"
                        textAnchor="middle"
                        fill="currentColor"
                        fontSize="13"
                        fontFamily="Georgia, serif"
                        fontStyle="italic"
                      >
                        better questions, better things.
                      </text>
                    </svg>
                    <p>
                      A question becomes a diagram. A diagram becomes something
                      you can try.
                    </p>
                    <button
                      className="console-secondary"
                      onClick={onProjects}
                    >
                      See the things that made it off the page ↗
                    </button>
                  </section>);
}
